import httpClient from '../utils/http'
import moment from 'moment'
import _ from 'lodash'
import { handleResponseAsync } from '../utils/HelperUtils'
import Chance from 'chance'
import { normalize } from 'normalizr'
import { viewConstants } from '../_constants/view.constants'
import { eventSchema } from '../entities/schema'
import { toast } from 'react-toastify'
import { post } from 'jquery'

toast.configure()

export const rosterService = {
           getAllETime,
           queryRoster,
           fetchETime,
           fetchEmployeeETime,
           updateEvent,
           updateOne,
           addEvent,
           addEventMulti,
           removeEventById,
           removeRosters,
           copyInsertEvents,
           submit,
           undoApproval,
       }

function convertViewModelList(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            const m = {}
            m.id = o.PayrollEmpRosterAutoID
            m.Title = o.PayrollEmpRosterDispTitle
            m.Note = o.PayrollEmpRosterActionNotes
            m.Break = o.PayrollEmpRosterBreakMinute
            m.start = moment(o.PayrollEmpRosterStartDate).toDate()
            m.end = moment(o.PayrollEmpRosterEndDate).toDate()
            m.EmployeeID = o.PayrollEmpRosterEmployeeID
            m.ActionType = o.PayrollEmpRosterActionTypeID
            m.Status = o.PayrollEmpRosterStatus
            m.CompanyId = o.PayrollEmpRosterCompanyID
            m.draggable = o.PayrollEmpRosterStatus !== 'approved' ? true : false
            m.source = o.source
            m.hours = o.PayrollEmpRosterHours

            m.Employee = o.Employee

            if (o.PayrollEmpRosterActionTypeID < 99) {
                m.allDay = true
            }
            viewModel.push(m)
        })
    }
    const eventListSchema = [eventSchema]
    const normalizedData = normalize(viewModel, eventListSchema)
    return normalizedData.entities
}

function addIdField(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            o.id = o.PayrollEmpRosterAutoID
            viewModel.push(o)
        })
    }
    return viewModel
}

function convertViewModel(data) {
    const m = {}
    if (!_.isEmpty(data)) {
        m.id = data.PayrollEmpRosterAutoID
        m.Title = data.PayrollEmpRosterDispTitle
        m.Note = data.PayrollEmpRosterActionNotes
        m.Break = data.PayrollEmpRosterBreakMinute
        m.start = moment(data.PayrollEmpRosterStartDate).toDate()
        m.end = moment(data.PayrollEmpRosterEndDate).toDate()
        m.EmployeeID = data.PayrollEmpRosterEmployeeID
        m.ActionType = data.PayrollEmpRosterActionTypeID
        m.Status = data.PayrollEmpRosterStatus
        m.CompanyId = data.PayrollEmpRosterCompanyID
        m.draggable = data.PayrollEmpRosterStatus !== 'approved' ? true : false
        m.hours = data.PayrollEmpRosterHours
    }
    const normalizedData = normalize(m, eventSchema)
    return normalizedData.entities
}

function convertById(data) {
    return data.PayrollEmpRosterAutoID
}

function castToModelNew(data, updateMode) {
    const vm = {}

    vm.PayrollEmpRosterActionNotes = data.Note || ''
    vm.PayrollEmpRosterDispTitle = data.Title || ''
    vm.PayrollEmpRosterStartDate = data.StartDate || data.start
    vm.PayrollEmpRosterEndDate = data.EndDate || data.end
    vm.PayrollEmpRosterActionTypeID = data.ActionType
    vm.PayrollEmpRosterBreakMinute = _.toNumber(data.Break) || 0
    vm.PayrollEmpRosterStatus = data.Status || 0
    vm.PayrollEmpRosterEmployeeID = data.EmployeeID
    vm.PayrollEmpRosterHours = data.Hours

    if (updateMode) {
        vm.dateFrom = data.dateFrom
        vm.dateTo = data.dateTo
    }

    return vm
}

function castToModelMultiEmp(data, updateMode) {
    const vm = {}

    if (undefined !== data.id) {
        vm.PayrollEmpRosterAutoID = data.id
    }

    vm.PayrollEmpRosterActionNotes = data.Note || ''
    vm.PayrollEmpRosterDispTitle = data.Title || ''
    vm.PayrollEmpRosterStartDate = data.StartDate || data.start
    vm.PayrollEmpRosterEndDate = data.EndDate || data.end
    vm.PayrollEmpRosterActionTypeID = data.ActionType
    vm.PayrollEmpRosterBreakMinute = _.toNumber(data.Break) || 0
    vm.PayrollEmpRosterStatus = data.Status || 0
    vm.PayrollEmpRosterEmployeeID = data.employeeID
    vm.PayrollEmpRosterHours = data.Hours
    vm.employees = data.employees

    if (updateMode) {
        vm.dateFrom = data.dateFrom
        vm.dateTo = data.dateTo
    }

    return vm
}

function getAllETime() {
    const url = '/api/etime'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function queryRoster(options) {
    const url = '/api/etime/query'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign({}, defaultQueryCond, options);

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => addIdField(res.data))
}

function fetchETime(options) {
    const url = '/api/etime/query'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign({}, defaultQueryCond, options);
    // let queryCond = options || defaultQueryCond

    // const config = {
    //     url: _url,
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    //     method: 'post',
    //     data: queryCond,
    // }

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function fetchEmployeeETime(options) {
    const { employeeID } = options
    // const _url = `/api/etime/query/${employeeID}`
    const url = `/api/etime/query/1`

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign(options, defaultQueryCond)

    // const config = {
    //     url: _url,
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    //     method: 'post',
    //     data: queryCond,
    // }

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateEvent(evt) {
    const url = '/api/etime'
    const payload = castToModelMultiEmp(evt, true)

    return httpClient
        .put(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateOne(payload) {
    const url = '/api/etime/UpdateOne'
    // const payload = castToModelMultiEmp(evt, true)

    return httpClient
        .put(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function removeEventById(evtId) {
    const url = `/api/etime/${evtId}`

    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}

/**
 * bulk delete
 * @param {*} evtId 
 * @returns 
 */
function removeRosters(payload) {
    const url = `/api/etime/delete`

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}

function addEvent(payload) {
    const url = '/api/etime'
    // const payload = castToModelNew(evt)

    // delete payload.PayrollEmpRosterAutoID

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function addEventMulti(evt) {
    const url = '/api/etime/m'
    const payload = castToModelMultiEmp(evt)

    delete payload.PayrollEmpRosterAutoID

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function copyInsertEvents(data){
    const url = '/api/etime/copy'

    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function submit(recordIds){
    const url = '/api/etime/submit'

    return httpClient
        .post(url, recordIds)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

/**
 * 
 * @param {*} recordIds 
 * @returns 
 */
function undoApproval(recordIds){
    const url = '/api/etime/reject'

    return httpClient
        .post(url, recordIds)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}